import { LoginValues } from "api/interfaces/login";
import { ApiService } from "api/services/apiClientService";
import { useState } from "react";
import { generatePath, useLocation, useNavigate } from "react-router-v7";
import { routePath } from "rooting/routes";
import { getUserDataFromAccessToken, UserRole } from "shared";
import { appStore } from "stores/appStore";
import { userStore } from "stores/userStore/userStore";

export const useLoginLogic = () => {
	const [loginError, setLoginError] = useState(false);
	const navigate = useNavigate();
	const location = useLocation()

	const sendRequest = async (data: LoginValues) => {
		setLoginError(false);
		try {
			appStore.setIsLoading(true);
			const res = await ApiService.login(data);
			if (res.success) {
				const tokenData = getUserDataFromAccessToken(res.data.accessToken);
				userStore.setUserContext(tokenData);

				const navigationPath = tokenData?.roles === UserRole.LocationAdmin
					? generatePath(routePath.alerts, { locationId: tokenData.userWorkplaceId })
					: routePath.locations

				return navigate(location.state?.from || navigationPath);

			} else setLoginError(true);
		} catch (error) {
			setLoginError(true);
		} finally {
			appStore.setIsLoading(false);
		}
	};

	return { loginError, sendRequest }
}
